module.exports = __webpack_public_path__ + "img/no_data.e830ffe4.png";